<template>
  <div class="main-block">
    <div class="table -users-table-">
      <div class="table__header">
        <div class="table__header-inner">
          <p class="table__title">
            Список пользователей
          </p>
          <SearchFilter
            contacts="true"
            store-path="users"
          />
          <div
            v-if="$permissionsCreate"
            class="table__buttons"
          >
            <Button
              class="-s-"
              @click="openAside"
            >
              Добавить пользователя
            </Button>
          </div>
        </div>
      </div>
      <div class="table__body">
        <div class="table__body-content">
          <div class="table__nav">
            <ul class="table__nav-list">
              <li
                v-for="(item, index) in tableItems"
                :key="index"
                class="table__col"
              >
                <p class="table__col-title">
                  {{ item.title }}
                </p>
              </li>
            </ul>
          </div>
          <div class="table__content">
            <PageScroll
              v-if="!loadedUsers"
              :data="users"
              :is-loading="loadedUsers || isAddingPage"
              @incrementPage="addingPage"
            >
              <TableRow
                v-for="(user, index) in users"
                :key="index"
                :user="user"
                :groups="groups"
                @click="deleteUser"
              />
              <SkeletRow
                v-if="isAddingPage"
                :permissions-update="$permissionsUpdate"
              />
            </PageScroll>
            <template v-else>
              <SkeletRow
                v-for="i in 5"
                :key="i"
                :permissions-update="$permissionsUpdate"
              />
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableRow from './components/Row';
import SkeletRow from './components/SkeletRow';
import { mapState, mapActions } from 'vuex';

export default {
  components: { TableRow, SkeletRow },
  computed: {
    ...mapState('users', {
      users: s => s.data.users,
      loadedUsers: s => s.meta.loadedUsers,
      groups: s => s.data.groups,
      isAddingPage: s => s.meta.isAddingPage,
      noMorePage: s => s.meta.noMorePage
    }),
    ...mapState('auth', {
      $permissions: s => s.data.user.permissions.userModuleAdmin,
      isAdmin: s => s.data.user.permissions.isAdmin
    }),
    tableItems () {
      const items = [
        { title: 'ID' },
        { title: 'ФИО' },
        { title: 'Город' },
        { title: 'Email' },
        { title: 'Телефон' },
        { title: 'Группы' },
        { title: 'Соц. сети' },
        { title: 'Ниша' },
        { title: 'Прибыль в неделю' }
      ];
      if (this.$permissionsUpdate) {
        items.push({ title: 'Действия' });
      }
      return items;
    }
  },
  mounted() {
    this.$store.dispatch('auth/getCoursesForEmail');
  },
  methods: {
    ...mapActions('users', ['setAsideMeta', 'setAsideData', 'addPage', 'searchMethods']),
    openAside() {
      this.setAsideData({ path: 'user', value: {} });
      this.setAsideMeta({ path: 'isOpen', value: true });
    },
    addingPage(id) {
      if (this.noMorePage) {
        return;
      }
      this.addPage({ page: id });
    },
    deleteUser({ groupId, user }) {
      this.$store.dispatch('usersGroupsUsers/deleteUser', {
        user: user,
        groupId: groupId
      });
    }
  }
};
</script>
